export default __webpack_public_path__ + "static/media/logo-white-font.858a19b1.png";